<template>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row v-if="item">
        <b-col>
          <router-link v-if="prevRoute.name === 'TimetableDashboard'" :to="{ name: 'TimetableDashboard' }" class="btn btn-default float-right">
            <span v-if="!mobileView">{{$t('buttons.backToCRM')}}</span>
            <i v-else class="far fa-arrow-alt-left"></i>
          </router-link>
          <router-link v-else :to="{ name: 'EXCMRelationList' }" class="btn btn-default float-right">{{$t('buttons.backToList')}}</router-link>
          <router-link class="btn" :to="{name: 'EXCMRelationUpdate', params: { id: item['@id'] }}">
            {{ $t('buttons.edit') }}
          </router-link>
          <!--<button class="btn btn-danger" @click="deleteItem(item)">{{ $t('buttons.delete') }}</button>-->
          <button class="btn btn-warning" @click="archiveItem(item)">{{ $t('buttons.archive') }}</button>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <b-card>
            <div class="card-body">
              <b-row v-if="item">
                <b-col>
                  <p><b>{{$t('views.excmrelation.show.name')}}:</b> {{ item.title }}</p>
                  <p><b>{{$t('views.excmrelation.show.description')}}:</b> {{ item.description }}</p>
                  <p><b>{{$t('views.excmrelation.show.dateFrom')}}:</b> {{ $moment(item.dateFrom).format('YYYY-MM-DD HH:mm') }}</p>
                  <p><b>{{$t('views.excmrelation.show.dateTo')}}:</b> {{ $moment(item.dateTo).format('YYYY-MM-DD HH:mm') }}</p>
                  <p><b>{{$t('views.excmrelation.show.userData')}}:</b> {{ item.userData.firmname1 }}</p>
                </b-col>
              </b-row>
              <b-row class="mt-2">
                <b-col cols="12">
                  <h6>{{$t('views.excmrelation.show.relationUserData')}}:</h6>
                </b-col>
                <b-col cols="12" v-for="(relationUserDataItem, relationUserDataIndex) in item.relationUserData" v-bind:key="'relationUserDataItem-' + relationUserDataIndex">
                  <b-row>
                    <b-col sm="12" lg="1">
                      <h5 class="text-center">#{{ relationUserDataIndex + 1 }}</h5>
                    </b-col>
                    <b-col sm="12" lg="8">
                      <p class="mb-0 mt-1" v-bind:class="{ 'text-center': mobileView }">{{ relationUserDataItem.userData.name }} {{ relationUserDataItem.userData.surname }}</p>
                    </b-col>
                    <b-col sm="12" lg="3">
                      <div v-bind:class="{ 'float-right': !mobileView }">
                        <b-btn class="btn btn-danger mt-2" size="sm" @click="removeRelationUserData(relationUserDataIndex)">
                          <span v-if="!mobileView">{{ $t('buttons.delete') }}</span>
                          <i v-else class="far fa-trash-alt"></i>
                        </b-btn>
                      </div>
                    </b-col>
                    <b-col cols="12" v-if="item.relationUserData.length > (relationUserDataIndex + 1)">
                      <hr class="mt-1 mb-1">
                    </b-col>
                  </b-row>
                </b-col>
                <b-col cols="12">
                  <b-btn variant="success" @click="createRelationUserData()">{{ $t('views.excmrelation.show.createRelationUserData') }}</b-btn>
                </b-col>
              </b-row>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <EXCMRelationUserDataCreateModal></EXCMRelationUserDataCreateModal>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import getId from '@/utils/getIdFromLink'
import Loader from '../../Layout/Loader'
import EXCMRelationUserDataCreateModal from '../excmrelationuserdata/components/EXCMRelationUserDataCreateModal'

export default {
  computed: {
    ...mapGetters({
      deleteError: 'excmrelation/del/error',
      error: 'excmrelation/show/error',
      isLoading: 'excmrelation/show/isLoading',
      item: 'excmrelation/show/retrieved'
    }),

    mobileView () {
      return this.$store.state.mobileView
    },

    excmRelationUserDataCreated () {
      return this.$store.state.modals.excmrelationuserdata.create.created
    }
  },

  watch: {
    excmRelationUserDataCreated: function (val) {
      if (val === 1) {
        this.$store.state.modals.excmrelationuserdata.create.created = 0
        this.retrieve(decodeURIComponent(this.$route.params.id))
      }
    }
  },

  components: {
    Loader,
    EXCMRelationUserDataCreateModal
  },

  beforeDestroy () {
    this.reset()
  },
  data () {
    return {
      prevRoute: null
    }
  },
  beforeRouteEnter (to, from, next) {
    next((vm) => {
      vm.prevRoute = from
    })
  },
  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      del: 'excmrelation/del/del',
      reset: 'excmrelation/show/reset',
      retrieve: 'excmrelation/show/retrieve'
    }),

    createRelationUserData () {
      this.$store.state.modals.excmrelationuserdata.create.show = 1
      this.$store.state.modals.excmrelationuserdata.create.relation = this.item
    },

    removeRelationUserData (item) {
      this.$Swal({
        title: this.$t('notifications.deleteTitle'),
        type: 'question',
        showConfirmButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        showCancelButton: true,
        cancelButtonText: this.$t('buttons.cancel')
      }).then((result) => {
        if (result) {
          this.delTeam(item).then(() => this.retrieve(decodeURIComponent(this.$route.params.id)))
        }
      })
    },

    archiveItem (item) {
      this.$Swal({
        title: this.$t('notifications.archiveTitle') + ' ' + this.$t('notifications.archiveDescription'),
        type: 'question',
        showConfirmButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        showCancelButton: true,
        cancelButtonText: this.$t('buttons.cancel')
      }).then((result) => {
        if (result) {
          this.$http
            .put('api/e_x_c_m_relations/' + this.getIdLink(this.item['@id']), {
              state: 0
            })
            .then(response => {
              this.$router.push({ name: 'EXCMRelationList' })
              this.$Swal({ // show notification with success
                type: 'success',
                title: this.$t('notifications.update.updatedTitle'),
                showConfirmButton: false,
                timer: 2500
              })
            })
            .catch(error => {
              if (error.response.status === 400) {
                let text = ''
                for (let i in error.response.data) {
                  text += error.response.data[i] + '\n'
                }
                this.$Swal({
                  type: 'warning',
                  title: text,
                  timer: 2500
                })
              }
              console.log(error)
            })
        }
      })
    },
    getIdLink (link) {
      return getId(link)
    },

    deleteItem (item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        this.del(item).then(() => this.$router.push({ name: 'EXCMRelationList' }))
      }
    }
  }
}
</script>
